export enum EmploymentType {
  NONE = 'NONE',
  W2 = 'W2',
  CONTRACTOR_1099 = 'CONTRACTOR_1099',
}

export enum EmploymentContractStatus {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  TERMINATED = 'TERMINATED',
}

export const employmentTypeItems = [
  { value: EmploymentType.CONTRACTOR_1099, label: '1099 Contractor' },
  { value: EmploymentType.W2, label: 'W2' },
]

export type CompanyEmploymentType = Exclude<EmploymentType, EmploymentType.NONE>

export const COMPANY_EMPLOYMENT_TYPE_OPTIONS: CompanyEmploymentType[] = [
  EmploymentType.W2,
  EmploymentType.CONTRACTOR_1099,
]

export const SELECTABLE_EMPLOYMENT_TYPES: EmploymentType[] = Object.values(
  EmploymentType,
).filter((et) => et !== EmploymentType.NONE)
